import React, { useEffect, useState } from 'react'
import Layout from '../../common/Layout'
import { dispatchMmvData } from '../../store/actions/userActions';
import { useDispatch, useSelector } from 'react-redux';
import { GetDataWithToken, PostDataWithToken } from '../../constants/ApiHelper';
import ReactPaginate from 'react-paginate';
import ReactSelect from 'react-select'
import { toast } from 'react-toastify';

const Relation = () => {
    const mmvData = useSelector(state => state?.root?.mmvData)

    const dispatch = useDispatch()
    const [insurer, setInsurer] = useState('')
    const [insurerData, setInsurerData] = useState([])
    const [errors, setErrors] = useState({})
    const [loading, setLoading] = useState(false)
    const [currentItemsData, setCurrentItemsData] = useState(false)
    const [insurerRtoData, setInsurerRtoData] = useState([])
    const [partnerRtoData, setPartnerRtoData] = useState([])
    const [stateData, setStateData] = useState([])
    const [filter, setFilter] = useState(false)
    const [selectedState, setSelectedState] = useState(null)
    const [stateId, setStateId] = useState('')
    const [cityId, setCityId] = useState('')
    const [cityData, setCityData] = useState([])
    const [selectedCity, setSelectedCity] = useState(null)
    const [rtoData, setRtoData] = useState([])
    const [selectedRto, setSelectedRto] = useState(null)
    const [selectedValue, setSelectedValue] = useState({})
    const [selectedStatus, setSelectedStatus] = useState('')
    const [action, setAction] = useState(false)
    const [resetAction, setResetAction] = useState(false)
    const [variantIdInput, setVariantIdInput] = useState('')
    const [pagination, setPagination] = useState('')


    const [page, setPage] = useState(1)
    const [itemsPerPage, setItemsPerPage] = useState(10)
    const [itemOffset, setItemOffset] = useState(0)
    const handlePageClick = (selectedItem) => {
        setPage(selectedItem.selected + 1);
    };

    const endOffset = itemOffset + itemsPerPage
    const currentItems =
        partnerRtoData && partnerRtoData.slice(itemOffset, endOffset)
    const handleChangeItemPerPage = (e) => {
        const value = Number(e.target.value);

        setItemsPerPage(value);
        setPage(1);
    };
useEffect(() => {
  if (!currentItemsData) return;

  getPartnerRto();
}, [page, itemsPerPage, variantIdInput]);
      
    

    const handleSelectProduct = () => {
        setLoading(true);

        // Add query parameters correctly, removing any extra commas
        let data = new URLSearchParams({
            isMmvPanel: true,
        }).toString();

        GetDataWithToken(`/insurers/getAllInsurer?${data}`).then(res => {
            setLoading(false);
            if (res?.success) {
                setInsurerData(res?.data);
            } else {
                console.log('Insurer Data', res?.status);
            }
        });
    }
    useEffect(() => {
        handleSelectProduct();
    }, []);
    const handleSelectInsurer = (val, insurerData) => {

        setInsurer(val)
        setCurrentItemsData(false)
        dispatchMmvData('insurerId', val)


        dispatchMmvData('insurerRtoId', '')
        const selectedInsurer = insurerData.find((x) => x.insurerId === parseInt(val))

        const insurerName = selectedInsurer ? selectedInsurer.insurerName : ''
        const mappingName = selectedInsurer ? selectedInsurer.mappingName : ''
        dispatchMmvData('insurerName', insurerName)
        dispatchMmvData('mappingName', mappingName)
    }
    const validateForm = () => {
        const newErrors = {}
        if (!insurer) newErrors.insurer = 'Please select an insurer.'
        setErrors(newErrors)
        return Object.keys(newErrors).length === 0
    }

    const getInsurerRto = () => {
        setLoading(true); // Start loading

        const insurerObj = {
            insurerId: mmvData?.insurerId || '',
        };

        PostDataWithToken('relation/getInsRelationData', insurerObj)
            .then((res) => {
                if (res?.status) {

                    const data = res?.data || [];
                    const arr = data.map((item) => ({
                        label: item?.relation,
                        value: item?.id,
                    }));

                    setInsurerRtoData(arr);
                } else {
                    console.error("Error in response:", res?.message || "Unknown error");
                }
            })
            .catch((err) => {
                console.error("Error in API call:", err);
            })
            .finally(() => {
                setLoading(false); // Stop loading
            });
    };

    useEffect(() => {
        currentItems.map(item => {
            const value = insurerRtoData.find(data => item?.kotak === data?.value)
        })
    }, [currentItems])

    const getPartnerRto = () => {
        setLoading(true)
        let partnerObj = {

            limit: itemsPerPage,
            page: page,
            search: variantIdInput,

        }

        PostDataWithToken('relation/getRelations', partnerObj).then(
            res => {
                setPartnerRtoData(res?.data)
                setPagination(res?.pagination)
                setLoading(false)
            }
        )
        // setModel(true)
    }

    const handleSubmit = () => {
        if (!validateForm()) return
        setCurrentItemsData(true)
        getInsurerRto()
        getPartnerRto()
        setLoading(true)

    }
    const handleSelectInsurerRtoId = (selectedOption, itemId) => {

        dispatchMmvData('insurerRtoId', selectedOption?.value)
        setSelectedValue(prevSelected => ({
            ...prevSelected,
            [itemId]: selectedOption
        }))
    }





    const handleMapping = (item, matchingRto) => {

        setLoading(true)
        let mapObj = {
            insRelationId: mmvData?.insurerRtoId
                ? mmvData?.insurerRtoId
                : matchingRto?.value,
            insurerId: mmvData?.insurerId,
            relationId: item,
            action: 'mapped'
        }
        PostDataWithToken('relation/relationMapUnmap', mapObj).then(res => {
            setLoading(false)
            if (res?.status) {
                toast.success(res.message)
            } else {
                toast.error(res.message)
            }
        })
    }
    //unmap data
    const handleUnMapping = itemId => {
        setLoading(true)
        let mapObj = {
            insRelationId: '',
            insurerId: mmvData?.insurerId,
            relationId: itemId,
            action: 'unmapped'
        }
        PostDataWithToken('relation/relationMapUnmap', mapObj).then(res => {
            setLoading(false)
            if (res?.status) {
                setSelectedValue(prevSelected => ({
                    ...prevSelected,
                    [itemId]: null
                }))
                toast.success(res?.message)
            } else {
                toast.error('Something went wrong')
            }
        })
    }
    const handleVariantIdChange = e => {
        setVariantIdInput(e.target.value)
    }
    const [searchType, setSearchType] = useState('search')
    const handleSearch = () => {
        if (searchType === 'search') {
            getPartnerRto('', '', '', variantIdInput)

        }
    }
    return (
        <Layout>
            <div className='container-fluid py-4 dash_main'>
                <div className='row'>
                    <div className='card mb-4'>
                        <div className='card-body pt-0 pb-2'>
                            <div className='row mt-2'>
                                <div className='col-xl-3 col-lg-3 col-md-6 col-12'>
                                    <label>Insurer</label>
                                    <div className='mb-3'>
                                        <select
                                            className='form-control'
                                            onChange={e =>
                                                handleSelectInsurer(e.target.value, insurerData)
                                            }
                                            value={insurer}
                                        >
                                            <option value=''>Select Insurance</option>
                                            {insurerData?.map((item, index) => (
                                                <option key={index} value={item?.insurerId}>
                                                    {item?.mappingName}
                                                </option>
                                            ))}
                                        </select>
                                        {errors.insurer && (
                                            <div className='text-danger'>{errors.insurer}</div>
                                        )}
                                    </div>
                                </div>

                                <div className='col-xl-3 col-lg-3 col-md-6 col-12'>
                                    <label></label>
                                    <div className='mb-3 d-flex justify-content-end gap-3'>
                                        <button
                                            type='button'
                                            className='btn btn-sec'
                                            onClick={handleSubmit}
                                            disabled={loading}
                                        >
                                            {loading ? 'Loading...' : 'Submit'}
                                        </button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>


                </div>

                {partnerRtoData ? (
                    <>
                        {/* </div> */}
                        {loading ? (
                            <>
                                <div className='loading'>
                                    <div className='spinner'></div>
                                    <p>Loading...</p>
                                </div>
                            </>
                        ) : (
                            <>
                                {partnerRtoData?.length > 0 ? (
                                    <div className='col-12'>
                                        <div className='card mb-4'>
                                            <div className='card-body pt-0 pb-2'>
                                                <div className='row'>
                                                    <div className='col-xl-3 col-lg-3 col-md-6 col-12 d-flex align-items-center gao-1'>
                                                        <div>
                                                            <label> Search Relation</label>
                                                            <div className='mb-3'>
                                                                <input
                                                                    type='search'
                                                                    placeholder='Search Relation'
                                                                    className='form-control'
                                                                    value={variantIdInput}
                                                                    onChange={handleVariantIdChange}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div
                                                            className='mt-3 secrch-btn'
                                                            onClick={() => handleSearch()}
                                                        >
                                                            <button>search</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='card-body pt-0 pb-2'>
                                                <div className='table-responsive p-0'>
                                                    <table className='table align-items-center mb-0'>
                                                        <thead>
                                                            <tr>
                                                                <th className='text-uppercase text-xxs font-weight-bolder text-dark'>
                                                                    Product Relation
                                                                </th>
                                                                <th className='text-uppercase text-xxs font-weight-bolder text-dark'>
                                                                     Insurer Relation
                                                                </th>
                                                                <th
                                                                    className='text-uppercase  text-xxs font-weight-bolder fs-4'
                                                                    style={{ color: '#000' }}
                                                                >
                                                                    Action
                                                                </th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {currentItems.map((item, index) => {
                                                                const insurerRtoId =
                                                                    item[mmvData?.mappingName]
                                                                const insurerName = mmvData?.mappingName
                                                                const matchingRto = insurerRtoData.find(
                                                                    data => data.value === insurerRtoId
                                                                )
                                                                const selectedRelation =
                                                                    Object.prototype.hasOwnProperty.call(
                                                                        selectedValue,
                                                                        item.id
                                                                    )
                                                                        ? selectedValue[item.id]
                                                                        : matchingRto || null
                                                                return (
                                                                    <tr key={index}>
                                                                        <td className='select_partner'>
                                                                            {item?.relation}
                                                                        </td>
                                                                        <td style={{ width: '45%' }}>
                                                                            <div className='mmv_select'>
                                                                                <ReactSelect
                                                                                    options={insurerRtoData}
                                                                                    name='relation'
                                                                                    value={selectedRelation}
                                                                                    placeholder='Select Insurer Relation'
                                                                                    onChange={selectedOption =>
                                                                                        handleSelectInsurerRtoId(
                                                                                            selectedOption,
                                                                                            item.id
                                                                                        )
                                                                                    }
                                                                                    className='select_ins'
                                                                                    menuPortalTarget={document.body}
                                                                                    // components={{ MenuList }}
                                                                                    styles={{
                                                                                        menuPortal: base => ({
                                                                                            ...base,
                                                                                            zIndex: 9999
                                                                                        })
                                                                                    }}
                                                                                />
                                                                            </div>
                                                                        </td>
                                                                        <td>
                                                                            <div className='d-flex gap-2'>
                                                                                <button
                                                                                    type='button'
                                                                                    className='btn btn-sec'
                                                                                    onClick={() =>
                                                                                        handleMapping(
                                                                                            item?.id,
                                                                                            selectedRelation
                                                                                        )
                                                                                    }
                                                                                    disabled={!selectedRelation}
                                                                                >

                                                                                    map
                                                                                </button>
                                                                                <button
                                                                                    type='button'
                                                                                    className='btn suc-btn'
                                                                                    onClick={() =>
                                                                                        handleUnMapping(item?.id)
                                                                                    }
                                                                                >

                                                                                    Unmap
                                                                                </button>
                                                                            </div>
                                                                        </td>
                                                                    </tr>
                                                                )
                                                            })}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                        <div className='card mb-4 p-3'>
                                            <div className='d-flex align-items-center justify-content-between flex-wrap'>
                                                <div>
                                                    <p>
                                                        Showing{" "}
                                                        {pagination?.totalRecords
                                                            ? (page - 1) * itemsPerPage + 1
                                                            : 0}
                                                        {" - "}
                                                        {Math.min(page * itemsPerPage, pagination?.totalRecords || 0)}
                                                        {" of "}
                                                        {pagination?.totalRecords || 0}
                                                    </p>
                                                </div>
                                                <div className='main-page-item'>
                                                    <div className='show-page'>
                                                        <select
                                                            className="form-control"
                                                            value={itemsPerPage}
                                                            onChange={handleChangeItemPerPage}
                                                        >
                                                            <option value={10}>10</option>
                                                            <option value={20}>20</option>
                                                            <option value={30}>30</option>
                                                            <option value={50}>50</option>
                                                            <option value={100}>100</option>
                                                        </select>
                                                    </div>
                                                    <div>
                                                        <ReactPaginate
                                                            breakLabel="..."
                                                            previousLabel="<"
                                                            nextLabel=">"
                                                            onPageChange={handlePageClick}
                                                            pageCount={pagination?.totalPages || 0}
                                                            //   forcePage={page - 1}
                                                            pageRangeDisplayed={5}
                                                            marginPagesDisplayed={2}
                                                            renderOnZeroPageCount={null}
                                                            pageClassName="page-item"
                                                            pageLinkClassName="page-link"
                                                            previousClassName="page-item"
                                                            previousLinkClassName="page-link"
                                                            nextClassName="page-item"
                                                            nextLinkClassName="page-link"
                                                            breakClassName="page-item"
                                                            breakLinkClassName="page-link"
                                                            containerClassName="pagination"
                                                            activeClassName="active"
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <p style={{ textAlign: 'center', fontSize: '1rem' }}>
                                        {' '}
                                        No Record Found
                                    </p>
                                )}
                            </>
                        )}
                    </>
                ) : (
                    <>
                        <p style={{ textAlign: 'center', fontSize: '1rem' }}>
                            {' '}
                            No Record Found
                        </p>
                    </>
                )}

            </div>
        </Layout>
    )
}

export default Relation
